import { __decorate } from "tslib";
import { AutoEncoder, StringDecoder, field, IntegerDecoder, ArrayDecoder, DateDecoder } from '@simonbackx/simple-encoding';
export class UitpasEventResponse extends AutoEncoder {
    url;
    name;
    location;
    startDate = null;
    endDate = null;
}
__decorate([
    field({ decoder: StringDecoder })
], UitpasEventResponse.prototype, "url", void 0);
__decorate([
    field({ decoder: StringDecoder })
], UitpasEventResponse.prototype, "name", void 0);
__decorate([
    field({ decoder: StringDecoder })
], UitpasEventResponse.prototype, "location", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], UitpasEventResponse.prototype, "startDate", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], UitpasEventResponse.prototype, "endDate", void 0);
export class UitpasEventsResponse extends AutoEncoder {
    totalItems;
    itemsPerPage;
    member;
}
__decorate([
    field({ decoder: IntegerDecoder })
], UitpasEventsResponse.prototype, "totalItems", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], UitpasEventsResponse.prototype, "itemsPerPage", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(UitpasEventResponse) })
], UitpasEventsResponse.prototype, "member", void 0);
//# sourceMappingURL=UitpasEventsResponse.js.map